var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImageLarge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.4999 14.6821L18.9199 5.93735V5.94485C18.3349 5.34487 17.3825 5.34487 16.79 5.92985L0.5 22.1669V1.99996C0.5 1.17498 1.175 0.5 2 0.5H25.9999C26.8249 0.5 27.4999 1.17498 27.4999 1.99996V14.6821ZM2.59248 7.73731C2.59248 9.39476 3.93497 10.7372 5.59247 10.7372C7.24996 10.7372 8.59246 9.39476 8.59246 7.73731C8.59246 6.07985 7.24996 4.73739 5.59247 4.73739C3.93497 4.73739 2.59248 6.07985 2.59248 7.73731ZM0.5 26V25.34L16.7675 9.11792C17.36 8.53293 18.3125 8.54043 18.8974 9.13292L27.4999 17.8927V26C27.4999 26.8249 26.8249 27.4999 25.9999 27.4999H2C1.175 27.4999 0.5 26.8249 0.5 26Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageLarge);
export default __webpack_public_path__ + "static/media/image-large.31c66b25c340d3e21b1b1cae57ff5940.svg";
export { ForwardRef as ReactComponent };